<form-control
  [direction]="config.noDirection ? undefined : 'grouping'"
  [config]="config"
  [control]="formGroup.get(config.prop)"
>
</form-control>
